// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  text-align: right;
  font-size: 20px;
}

ion-button {
  text-transform: none;
}

.side-menu-button-container {
  display: flex;
  flex-direction: column;
  width: 100% !important;
}
.side-menu-button-container ion-button {
  margin-top: var(--d-spacing-triple);
  --padding-start: var(--d-spacing-double);
}
.side-menu-button-container ion-button span {
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.side-menu-button-container ion-button span img {
  margin-right: var(--d-spacing-double);
}
.side-menu-button-container ion-button span ion-label {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  margin: 0 !important;
  font-size: 18px !important;
  font-weight: bold;
  align-self: center;
}

.side-menu-active-button {
  color: var(--ion-color-primary) !important;
}

.side-menu-legal-buttons {
  margin-left: var(--d-spacing-single);
}
.side-menu-legal-buttons ion-button {
  margin-top: var(--d-spacing-double);
  width: 100%;
}
.side-menu-legal-buttons ion-button span ion-label {
  font-weight: normal;
}

.side-menu-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.side-menu-close-button {
  --padding-end: calc(var(--d-spacing-single) * 1.5);
  --padding-top: calc(var(--d-spacing-single) * 1.5);
  --padding-bottom: calc(var(--d-spacing-single) * 1.5);
  --margin-end: 0;
  --margin-top: 0;
  --margin-bottom: 0;
  font-size: x-large;
  font-weight: 2000;
}`, "",{"version":3,"sources":["webpack://./src/app/side-menu/dwin-side-menu.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;EACA,eAAA;AADJ;;AAIA;EACI,oBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,sBAAA;AADJ;AAGI;EACI,mCAAA;EACA,wCAAA;AADR;AAEQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAAZ;AAEY;EACI,qCAAA;AAAhB;AAGY;ECpBR,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDmBY,oBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AAEhB;;AAIA;EACI,0CAAA;AADJ;;AAIA;EACI,oCAAA;AADJ;AAGI;EACI,mCAAA;EACA,WAAA;AADR;AAIY;EACI,mBAAA;AAFhB;;AAQA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AALJ;;AAQA;EACI,kDAAA;EACA,kDAAA;EACA,qDAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AALJ","sourcesContent":["@import 'src/mixins.scss';\n\nion-toolbar {\n    text-align: right;\n    font-size: 20px;\n}\n\nion-button {\n    text-transform: none;\n}\n\n.side-menu-button-container {\n    display: flex;\n    flex-direction: column;\n    width: 100% !important;\n\n    ion-button {\n        margin-top: var(--d-spacing-triple);\n        --padding-start: var(--d-spacing-double);\n        span {\n            width: 100%;\n            display: flex;\n            align-items: flex-start;\n\n            img {\n                margin-right: var(--d-spacing-double);\n            }\n\n            ion-label {\n                @include p1-style;\n                margin: 0 !important;\n                font-size: 18px !important;\n                font-weight: bold;\n                align-self: center;\n            }\n        }\n    }\n}\n\n.side-menu-active-button {\n    color: var(--ion-color-primary) !important;\n}\n\n.side-menu-legal-buttons {\n    margin-left: var(--d-spacing-single);\n\n    ion-button {\n        margin-top: var(--d-spacing-double);\n        width: 100%;\n\n        span {\n            ion-label {\n                font-weight: normal;\n            }\n        }\n    }\n}\n\n.side-menu-content-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n}\n\n.side-menu-close-button {\n    --padding-end: calc(var(--d-spacing-single) * 1.5);\n    --padding-top: calc(var(--d-spacing-single) * 1.5);\n    --padding-bottom: calc(var(--d-spacing-single) * 1.5);\n    --margin-end: 0;\n    --margin-top: 0;\n    --margin-bottom: 0;\n    font-size: x-large;\n    font-weight: 2000;\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
